const MarketingOptIn = ({   
  id = "accepts_marketing",
  label,
  checked,
  onChange,
  disabled = false,
  required = false  }) => {
  return (
    <div
    onMouseUp={() => {
      if (!disabled) {
        document.getElementById(id).click();
      }
    }}
      disabled={disabled}
      className={`p-6 border-2 border-dashed border-gray-300 rounded-lg flex items-start hover:bg-purple-100 cursor-pointer ${
        checked ? "bg-purple-100" : ""
      }`}
    >
      <input
          type="checkbox"
          id={id}
          name={id}
          checked={checked}
          onChange={onChange}
           
          disabled={disabled}
          className="mr-2 h-4 w-4"
          required={required}
          value="accepts_marketing"
      />
      <div>
        <div className="flex items-center mb-2">
          <div className="bg-purple-100 p-2 rounded-full mr-2">
            <svg
              className="h-5 w-5 text-purple-700"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          </div>
          <h4 className="text-xl font-bold text-purple-800">Perks</h4>
        </div>
        <p className="text-gray-700">
          Join our <span className="font-semibold">L&D Insider</span>{" "}
          network today to get the latest FREE content, offers,
          insights, research, and more
        </p>
      </div>
    </div>
  );
};
export default MarketingOptIn;
